import { BudgetDto } from '@/types';

const tasks = (state: BudgetDto | null = null, action) => {
    switch (action.type) {
        case 'SET_BUYER_BUDGET':
            return action.data;
        default:
            return state;
    }
};

export default tasks;